export const PROGRAM_COST = [
    {
        "value": "CostFree",
        "label": "Free"
    },
    {
        "value": "Cost1-10",
        "label": "$1-10 USD"
    },
    {
        "value": "Cost11-100",
        "label": "$11-100 USD"
    },
    {
        "value": "Cost101-500",
        "label": "$101-500 USD"
    },
    {
        "value": "Cost501-1000",
        "label": "$501-1000 USD"
    },
    {
        "value": "CostMore1000",
        "label": "More than $1000 USD"
    },
];

export const PROGRAM_COST_MAP = {
    "CostFree": {
        "label": "Free"
    },
    "Cost1-10": {
        "label": "$1-10 USD"
    },
    "Cost11-100": {
        "label": "$11-100 USD"
    },
    "Cost101-500": {
        "label": "$101-500 USD"
    },
    "Cost501-1000": {
        "label": "$501-1000 USD"
    },
    "CostMore1000": {
        "label": "More than $1000 USD"
    },
};